// @ts-nocheck
import ga from "@store/Framework/Common/GoogleAnalytics";

const getItemDiscountParameters = (
    listPrice: number | undefined,
    netPrice: number | undefined,
): Toolkit.GoogleAnalytics.Item => {
    if (typeof listPrice === "undefined" || typeof netPrice === "undefined") {
        return {};
    }

    const discount = ga.util.getDiscount(listPrice, netPrice);

    return {
        discount,
        discount_percentage: ga.util.getDiscountPercentage(discount, listPrice),
    };
};

export default getItemDiscountParameters;
